import React, { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { BtnBar, Form, SecondaryBtn, CtaBtn, WaitingAlert, Radio } from '@tmapy/style-guide';

import { useSubjektyListResource } from '../../openapi/operations/subjektyList';

import { PageTitle } from '../../app/components/PageTitle';
import { QUERY_STATE } from '../../constants';

const delegateMessages = defineMessages({
  delegateTitle: {
    id: 'doc.delegate.delegateTitle',
    defaultMessage: 'Vyberte SVÚ na které se má dokumentace delegovat',
  },
  btnCancel: {
    id: 'doc.delegate.btn.cancel',
    defaultMessage: 'Zrušit',
  },
  btnSubmit: {
    id: 'doc.delegate.btn.submit',
    defaultMessage: 'Potvrdit',
  },
  alertWaiting: {
    id: 'doc.delegate.alert.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
});

const SubjektItem = ({
  id,
  selectedId,
  onSelect,
}: {
  id: string;
  selectedId: string | null;
  onSelect: (id: string) => void;
}) => {
  const { data, queryState } = useSubjektyListResource({ id_subjektu__icontains: id });

  if (queryState === QUERY_STATE.WAITING)
    return (
      <WaitingAlert>
        <FormattedMessage {...delegateMessages.alertWaiting} />
      </WaitingAlert>
    );

  return (
    <Radio
      key={id}
      value={id}
      name='subjekt'
      isChecked={selectedId === id}
      onChange={() => onSelect(id)}
    >
      {data?.results?.[0]?.nazev || id}
    </Radio>
  );
};

interface DelegateProps {
  idSubjektu: string[];
  onCancelBtnClick(): void;
  partialUpdateCallback(data: any): void;
}

export const Delegate: React.FC<DelegateProps> = ({
  onCancelBtnClick,
  idSubjektu,
  partialUpdateCallback,
}) => {
  const [selectedId, setSelectedId] = useState<string>(idSubjektu[0]);

  const handleSubmit = () => {
    partialUpdateCallback(selectedId);
  };

  const handleCancelBtnClick = () => {
    onCancelBtnClick();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='sg-a-p-4 sg-u-vs-2'>
        <PageTitle>
          <FormattedMessage {...delegateMessages.delegateTitle} />
        </PageTitle>
        <div
          className={classNames({
            'sg-a-d-f sg-a-rg-1': true,
            'sg-a-fd-c': true,
          })}
        >
          {idSubjektu.map((item) => (
            <SubjektItem key={item} id={item} selectedId={selectedId} onSelect={setSelectedId} />
          ))}
        </div>

        <BtnBar>
          <CtaBtn type='submit'>
            <FormattedMessage {...delegateMessages.btnSubmit} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleCancelBtnClick}>
            <FormattedMessage {...delegateMessages.btnCancel} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </Form>
  );
};
